import { InjectionToken } from '@angular/core';
import { DocumentTypesState } from '../types/document-types.signal-state.type';
import { GridType } from '@data-access/grid-views';
import { DEFAULT_BASE_GRID_PROPS } from '@data-access/shared';

/**
 * Initial state for document types admin
 */
export const DOCUMENT_TYPES_INITIAL_STATE: DocumentTypesState = {
  data: [],
  views: [],
  gridType: 'document-type' as GridType,
  ...DEFAULT_BASE_GRID_PROPS,
};

/**
 * Injection token for document types admin initial state
 */
export const DOCUMENT_TYPES_ADMIN_INITIAL_STATE_TOKEN =
  new InjectionToken<DocumentTypesState>('document types admin grid state', {
    factory: () => ({ ...DOCUMENT_TYPES_INITIAL_STATE }),
  });
